import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = ["href"];
const _hoisted_2 = {
    key: 0,
    class: "prof_data"
};
const _hoisted_3 = { class: "dl_data" };
const _hoisted_4 = { class: "private_area" };
const _hoisted_5 = { class: "private_box" };
const _hoisted_6 = { class: "dl_data" };
const _hoisted_7 = { class: "profile_conditions_area" };
const _hoisted_8 = { class: "dl_data" };
const _hoisted_9 = { class: "dl_data_side" };
const _hoisted_10 = { class: "dl_data" };
const _hoisted_11 = { class: "dl_data" };
const _hoisted_12 = { class: "dl_data_side" };
const _hoisted_13 = { class: "dl_data" };
const _hoisted_14 = { class: "profile_conditions_area" };
const _hoisted_15 = { class: "dl_data" };
const _hoisted_16 = { key: 0 };
const _hoisted_17 = { key: 1 };
const _hoisted_18 = { class: "list_side" };
const _hoisted_19 = { class: "dl_data" };
import { ref } from "vue";
import ProfileDdText from "@/components/planner/ProfileDdText.vue";
import ProfileDdList from "@/components/planner/ProfileDdList.vue";
import { PLANNER_EXPERIENCES } from "@/constants/constants";
export default /*@__PURE__*/ _defineComponent({
    __name: 'Profile',
    props: {
        planner: {}
    },
    setup(__props) {
        const props = __props;
        const planner = ref(props.planner);
        const getExperience = (experience) => {
            return PLANNER_EXPERIENCES[experience];
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("a", {
                    href: `https://works.bridal-oshigoto.com/planner/${planner.value.accessCd}`
                }, "本サイトで確認", 8, _hoisted_1),
                (planner.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _cache[29] || (_cache[29] = _createElementVNode("h3", { class: "main_title" }, "基本情報", -1)),
                        _createElementVNode("dl", _hoisted_3, [
                            _cache[0] || (_cache[0] = _createElementVNode("dt", null, "お名前", -1)),
                            _createVNode(ProfileDdText, {
                                text: planner.value.user.name
                            }, null, 8, ["text"]),
                            _cache[1] || (_cache[1] = _createElementVNode("dt", null, "おなまえ（かな）", -1)),
                            _createVNode(ProfileDdText, {
                                text: planner.value.nameKana
                            }, null, 8, ["text"]),
                            _cache[2] || (_cache[2] = _createElementVNode("dt", null, "性別", -1)),
                            _createVNode(ProfileDdText, {
                                text: planner.value.gender
                            }, null, 8, ["text"]),
                            _cache[3] || (_cache[3] = _createElementVNode("dt", null, "生年月日", -1)),
                            _createVNode(ProfileDdText, {
                                text: planner.value.birthDate?.toLocaleString().slice(0, 10) ?? ''
                            }, null, 8, ["text"]),
                            _cache[4] || (_cache[4] = _createElementVNode("dt", null, "年齢", -1)),
                            _createVNode(ProfileDdText, {
                                text: planner.value.age?.toString() ?? ''
                            }, null, 8, ["text"]),
                            _cache[5] || (_cache[5] = _createElementVNode("dt", null, "現住所", -1)),
                            _createVNode(ProfileDdText, {
                                text: planner.value.address
                            }, null, 8, ["text"]),
                            _cache[6] || (_cache[6] = _createElementVNode("dt", null, "住所詳細", -1)),
                            _createVNode(ProfileDdText, {
                                text: planner.value.addressDetail
                            }, null, 8, ["text"]),
                            _cache[7] || (_cache[7] = _createElementVNode("dt", null, "緊急連絡先", -1)),
                            _createVNode(ProfileDdText, {
                                text: planner.value.phoneNumber
                            }, null, 8, ["text"])
                        ]),
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                                _cache[11] || (_cache[11] = _createElementVNode("h3", { class: "main_title" }, "非公開情報", -1)),
                                _createElementVNode("dl", _hoisted_6, [
                                    _cache[8] || (_cache[8] = _createElementVNode("dt", null, "メール", -1)),
                                    _createVNode(ProfileDdText, {
                                        text: planner.value.user.email ?? ''
                                    }, null, 8, ["text"]),
                                    _cache[9] || (_cache[9] = _createElementVNode("dt", null, "口座情報", -1)),
                                    _createVNode(ProfileDdText, {
                                        text: planner.value.bankAccount
                                    }, null, 8, ["text"]),
                                    _cache[10] || (_cache[10] = _createElementVNode("dt", null, "適格請求書発行事業者登録番号", -1)),
                                    _createVNode(ProfileDdText, {
                                        text: planner.value.invoiceSystem
                                    }, null, 8, ["text"])
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_7, [
                            _cache[20] || (_cache[20] = _createElementVNode("h3", { class: "main_title_02" }, "経験・スキル", -1)),
                            _createElementVNode("dl", _hoisted_8, [
                                _cache[12] || (_cache[12] = _createElementVNode("dt", null, "スキル", -1)),
                                _createVNode(ProfileDdList, {
                                    texts: planner.value.skills.split(',')
                                }, null, 8, ["texts"]),
                                _cache[13] || (_cache[13] = _createElementVNode("dt", null, "ブライダル経験年数", -1)),
                                _createVNode(ProfileDdText, {
                                    text: getExperience(planner.value.expYears)
                                }, null, 8, ["text"]),
                                _cache[14] || (_cache[14] = _createElementVNode("dt", null, "経験スタイル", -1)),
                                _createVNode(ProfileDdList, {
                                    texts: planner.value.hallTypes.split(',')
                                }, null, 8, ["texts"]),
                                _cache[15] || (_cache[15] = _createElementVNode("dt", null, "経験エリア", -1)),
                                _createVNode(ProfileDdList, {
                                    texts: planner.value.expAreas.split(',')
                                }, null, 8, ["texts"]),
                                _cache[16] || (_cache[16] = _createElementVNode("dt", null, "経歴（企業、所属会場、職種、期間）", -1)),
                                _createVNode(ProfileDdText, {
                                    text: planner.value.career
                                }, null, 8, ["text"])
                            ]),
                            _cache[21] || (_cache[21] = _createElementVNode("h3", { class: "main_title_02" }, "新規接客経験", -1)),
                            _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("dl", _hoisted_10, [
                                    _cache[17] || (_cache[17] = _createElementVNode("dt", null, "経験年数", -1)),
                                    _createVNode(ProfileDdText, {
                                        text: getExperience(planner.value.sinkiN)
                                    }, null, 8, ["text"])
                                ]),
                                _createElementVNode("dl", _hoisted_11, [
                                    _cache[18] || (_cache[18] = _createElementVNode("dt", null, "成約率", -1)),
                                    _createVNode(ProfileDdText, {
                                        text: planner.value.seiyakuR !== 0 ? planner.value.seiyakuR.toString() : ''
                                    }, null, 8, ["text"])
                                ])
                            ]),
                            _cache[22] || (_cache[22] = _createElementVNode("h3", { class: "main_title_02" }, "施行担当経験", -1)),
                            _createElementVNode("div", _hoisted_12, [
                                _createElementVNode("dl", _hoisted_13, [
                                    _cache[19] || (_cache[19] = _createElementVNode("dt", null, "経験年数", -1)),
                                    _createVNode(ProfileDdText, {
                                        text: getExperience(planner.value.uchiawaseN)
                                    }, null, 8, ["text"])
                                ])
                            ])
                        ]),
                        _cache[30] || (_cache[30] = _createElementVNode("h3", { class: "main_title" }, "希望条件", -1)),
                        _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("dl", _hoisted_15, [
                                (planner.value.workAreas)
                                    ? (_openBlock(), _createElementBlock("dt", _hoisted_16, "稼働可能エリア"))
                                    : _createCommentVNode("", true),
                                (planner.value.workAreas)
                                    ? (_openBlock(), _createElementBlock("dd", _hoisted_17, [
                                        _createElementVNode("ul", _hoisted_18, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(planner.value.workAreas.split(','), (workArea) => {
                                                return (_openBlock(), _createElementBlock("li", { key: workArea }, _toDisplayString(workArea), 1));
                                            }), 128))
                                        ])
                                    ]))
                                    : _createCommentVNode("", true),
                                _cache[23] || (_cache[23] = _createElementVNode("dt", null, "勤務可能日", -1)),
                                _createElementVNode("dd", null, _toDisplayString(planner.value.workDays), 1),
                                _cache[24] || (_cache[24] = _createElementVNode("dt", null, "月間出勤希望日数", -1)),
                                _createVNode(ProfileDdText, {
                                    text: planner.value.workDaysN.toString()
                                }, null, 8, ["text"]),
                                _cache[25] || (_cache[25] = _createElementVNode("dt", null, "勤務可能日備考", -1)),
                                _createVNode(ProfileDdText, {
                                    text: planner.value.workDayTxt
                                }, null, 8, ["text"])
                            ])
                        ]),
                        _cache[31] || (_cache[31] = _createElementVNode("h3", { class: "main_title" }, "アピールポイント", -1)),
                        _createElementVNode("div", null, [
                            _createElementVNode("dl", _hoisted_19, [
                                _cache[26] || (_cache[26] = _createElementVNode("dt", null, "新規接客アピールポイント", -1)),
                                _createVNode(ProfileDdText, {
                                    text: planner.value.appeal
                                }, null, 8, ["text"]),
                                _cache[27] || (_cache[27] = _createElementVNode("dt", null, "施行担当アピールポイント", -1)),
                                _createVNode(ProfileDdText, {
                                    text: planner.value.appealUchiawase
                                }, null, 8, ["text"]),
                                _cache[28] || (_cache[28] = _createElementVNode("dt", null, "その他アピールポイント", -1)),
                                _createVNode(ProfileDdText, {
                                    text: planner.value.appealOther
                                }, null, 8, ["text"])
                            ])
                        ])
                    ]))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
